module.exports = __webpack_public_path__ + "static/media/surfer1.8b3a3adf.gif";